export default "__VITE_ASSET__iOJauRqJ__"